export default __webpack_public_path__ + "static/media/24-3.b9e2ddff.mp3";